import { isPlatformBrowser } from '@angular/common';
import { Injectable, Inject, PLATFORM_ID, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageHandlerService {
  private isBrowser: boolean;

  private _localStorageRefService = inject(LocalStorageRefService);
  private _localStorage: Storage;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this._localStorage = this._localStorageRefService.localStorage;
    this.isBrowser = isPlatformBrowser(platformId);
  }

  public saveData(key: string, value: string): void {
    if (this.isBrowser) {
      this._localStorage.setItem(key, value);
    }
  }

  public getData(key: string): string | null {
    if (this.isBrowser) {
      return this._localStorage.getItem(key);
    }
    return null;
  }

  public removeData(key: string): void {
    if (this.isBrowser) {
      this._localStorage.removeItem(key);
    }
  }

  public clearData(): void {
    if (this.isBrowser) {
      this._localStorage.clear();
    }
  }
}

function getLocalStorage(): Storage {
  return localStorage;
}

@Injectable({providedIn: 'root'})
export class LocalStorageRefService {
  get localStorage(): Storage {
    return getLocalStorage();
  }
}